<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="$readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <DatePicker
      style="width: 100%;"
      :type="type"
      :value="value"
      :placeholder="label"
      :editable="false"
      :readonly="$readonly"
      :disabled="disabled"
      :format="format"
      :clearable="clearable"
      :start-date="start"
      :options="options"
      transfer
      :showWeekNumbers="showWeekNumbers"
      @on-change="onInputChange"
    ></DatePicker>
  </zpa-form-item>
</template>

<script>
import {
  dateToString,
} from '../utils'
import inputMixin from './mixins/input'

export default {
  name: 'zpaDateInput',

  mixins: [inputMixin],

  props: {
    type: {
      type: String,
      default: 'date',
    },

    value: {
      type: [String, Object, Array],
    },

    showWeekNumbers: Boolean,
    confirm: Boolean,
    format: String,
    startDate: String,
    disableDateType: String,
    disableDate: String,
  },

  computed: {
    start() {
      if (this.startDate) {
        var res = new Date(dateToString(this.startDate).replace(new RegExp('-', 'g'), ', '))
      }
      return res || new Date()
    },
    options() {
      var res = new Date(dateToString(this.disableDate).replace(new RegExp('-', 'g'), ', '))
      if (this.disableDateType && this.disableDateType.startsWith('small') && this.disableDate) {
        return {
          disabledDate(date) {
            return date && res ? (date.valueOf() > res.valueOf()) : false
          },
        }
      }
      if (this.disableDateType && this.disableDateType.startsWith('large') && this.disableDate) {
        return {
          disabledDate(date) {
            return date && res ? (date.valueOf() < res.valueOf()) : false
          },
        }
      }
      if (this.disableDateType && this.disableDateType === 'custom' && this.disableDate) {
        return {
          disabledDate: new Function('date', this.disabledDate),
        }
      }
      return {}
    },
  },
}
</script>
